<template>
  <div>
    <div class="container">
      <v-row>
          <v-col cols="12" lg="6" class="pa-0">
      <div class="info-login">
        <div class="header-info">
          <div class="logo">
            <v-img
              :src="logo"
              class="logo-icon"
            ></v-img>
          </div>
        </div>
        <div class="welcome">
          <span class="welcome-text"> Добро пожаловать</span>
        </div>
        <div class="info-login-content">
          <p class="login-p">Здесь вы можете зарегистрироваться на мероприятие</p>
          <button @click="goToRegistration" class="action">Создать личный кабинет</button>
        </div>
        <div class="circle"/>
      </div>
      </v-col>
      <v-col  cols="12" lg="6" class="pa-0">
      <div class="form-login">
        <div class="form-login-header">
          <div class="form-login-header-text">
            Вход
          </div>
        </div>
        <div class="form-auth">
          <v-text-field
            v-model="email"
            ref='name'
            label="Адрес электронной почты"
            required
            placeholder="info@ksrs.ru"
            :error="emailError"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show4 ? 'text' : 'password'"
            name="input-10-2"
            ref='password'
            placeholder="sdasd-dqw2-31c"
            label="Пароль"
            :error="passwordError"
            @click:append="show4 = !show4"
          ></v-text-field>
          <div>
            <v-btn
            :loading="preloaderLogin"
            @click="login()"
            class="login-button"
            :color="$mainColor">
            Вход
            </v-btn>
          </div>
          <br>
          <v-chip
            color="white"
            style="color:#4dbee1"
            @click="goToResetPassw()">
            <v-icon small class="mr-2"> mdi-login </v-icon>
            Восстановить пароль
          </v-chip>
        </div>
      </div>
      </v-col>
      </v-row>
    </div>


  </div>
</template>

<script>
import logo from '../assets/genom_3.png';
import ustoc from '../assets/ustoc.png';
import { mapActions, mapMutations, mapGetters } from 'vuex';

const reEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

export default {
  name: 'NewLogin',
  beforeMount() {
    if (localStorage.token) {
      this.$router.push('/user');
    }
    this.logo = logo
  },
  data: () => ({
      email: '',
      emailError: false,
      password: '',
      passwordError: false,
      logo: null,
      // ustoc: null,
      show4: false,
      preloaderLogin: false,
    }),

  mounted() {
  },
  components: {
    logo
  },
  created() {
    this.loading = true;
    localStorage.removeItem('token')
    localStorage.removeItem('isLoggedIn')
  },
  methods: {
    ...mapActions(['AUTH']),

    goToResetPassw() {
      this.$router.push('/reset-password');
    },
    goToRegistration() {
      this.$router.push('/registration');
    },
    async login() {

      this.preloader= true
      this.passwordError = false;
      this.emailError = false;

      if (reEmail.test(this.email) === false) {
        this.emailError = true;
        this.preloaderLogin = false
      }
      if (!this.password.trim() && this.password.length < 6) {
        this.passwordError = true;
      }
      if (this.passwordError || this.emailError) return;

      this.AUTH({
        login: this.email,
        password: this.password,
      })
      .then(res => {
        this.preloaderLogin = false
        this.$messageHelper('Успешно', 'success', 3000)
        this.$router.push('/personal-data')
        
      })
      .catch(e => {
        this.preloaderLogin = false
        this.$messageHelper(`Произошла ошибка: ${e.response.data.detail}`, 'error', 3000)
      })

    },
  },
};
</script>

<style scoped>

.info-login,
.form-login {
  z-index: 1;
}
.container{
  margin-left: 10px;
}
/* .container{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  display: flex;
  width:1100px;
  height: 550px;
  border-radius:30px;
  z-index: 1;
} */
  .info-login{
    text-align: center;
    position: relative;
    padding: 20px;
    /* width:50%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 570px;
    background: #4dbee1;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
     -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;

  }
  .form-login{
    text-align: center;
    background-color: white;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    position: relative;
    padding: 20px;
    /* width:50%; */
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 570px;
     -webkit-box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    box-shadow: 0 .46875rem 2.1875rem rgba(4,9,20,.03),0 .9375rem 1.40625rem rgba(4,9,20,.03),0 .25rem .53125rem rgba(4,9,20,.05),0 .125rem .1875rem rgba(4,9,20,.03)!important;
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;

  }
  .header-info{
    align-items: left;
    display: flex;
    padding-top: 55px;
    justify-content: space-between;

  }
  .logo{
    height: 55px;
    width:55px;
    position: relative;
    border:1px solid white;
    display: flex;
    border-radius: 50%;
  }
  .logo-icon{
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      position: absolute;
      height: 37px;
      width:37px;
  }
  .text-header-info{
    color: white;
    width:120px;
    font-weight: 550;
    font-size: 15px;
    line-height: 15px;
  }
  .bottom-line{
    width:70px;
    margin: 10px 0;
    height: 3px;
    background: white;
  }
  .welcome-text{
    font-weight: 1200;
    color: white;
    font-size: 30px ;
    font-weight: lighter;
  }
  .welcome{
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .login-p {
    font-size: 16px ;
    color: white;
    margin:0 0 20px;
  }
  .info-login-content{
    margin: 10px auto;
    width: 320px;
  }
  .info-login-content p{
    line-height: 19px;
  }
  .action{
    margin: 25px auto;
    width:270px;
    padding: 10px;
    background: #4dbee1;
    color: white;
    border: 1px solid white;
    border-radius:80px;
  }
  .action:hover{
    background: white;
    color: #4dbee1;
    cursor: pointer;
  }
  .name-info{
    width: 360px;
    margin-top: 45px;
    display: flex;
  }
  .text-info{
    font-size: 14px;
    line-height: 17px;
    color:white;
    margin-left: 15px;
    padding-top:5px;
  }
  .circle{
    border-radius: 100% 0 0 100% / 50% 0 0 50%;
    width: 100px;
    height: 170px;
    background: #4dbee1;
    border: 20px solid white;
    position: absolute;
    top: 60%;
    left: 85%;
  }
  .form-login-header {
    z-index: 1;
  }
  .form-login-header-text{
    color:#4dbee1;
    font-size: 25px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .line-bottom{
    width: 35px;
    height: 5px;
    background: #4dbee1;
    margin: 7px auto;
  }
  .login-button{
    margin-top:20px;
    background: #4dbee1;
    color: white;
    border-radius: 60px;
    width: 150px;
    padding: 7px 10px;
  }
.form-login::before {
  content: "";
  position: absolute;
  right: -76px;
  top: 20%;
  width: 150px;
  height: 150px;
  border: 30px solid transparent ;
  border-left: 30px solid #eeeeee;
  border-bottom: 30px solid #eeeeee;
  transform: rotate(45deg);
  border-radius: 30px;
  z-index: 1;}
  .login-lang{
    z-index: 1;
    position: absolute;
    top: 25px;
    left: 54%;
    width: max-content;
  }
  .en{
    background-color: #f8005c;
    color: white;
    margin-left: 0;
    border-radius: 20px;
    padding: 5px 25px 5px 10px;
  }
  .ru{
    padding: 5px 10px;
    border-radius: 20px;
    background-color: #003c72;
    color: #fff;
    margin-left: -20px;
  }

  @media screen and (max-width:959px) {
    /* .container {
      flex-direction: column;
      align-items: center;
      position: static;
      transform: none;
      width: auto;
      height: auto;
    } */
    .circle {
      left: calc(100% - 100px);
    }
    .info-login,
    .form-login {
      width: 85%;
    }
    .info-login {
      border-radius: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .form-login {
      border-radius: 0;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
  .form-auth {
    z-index: 1;
  }
</style>
